import { UseMutationOptions, useMutation } from 'react-query';

import { CreateTeamMember } from '@pimm/services/lib/sms-workforce/services';
import type { CreateTeamMemberRequest } from '@pimm/services/lib/sms-workforce/types';
import type { TeamMember } from '../types';

// POST /api/Workforce/TeamMembers — response is the full, enriched TeamMemberDto
// (same shape as a GET TeamMembers row), so callers should insert it into the
// cached list directly rather than refetching the site.
export const useCreateTeamMember = (options?: UseMutationOptions<TeamMember, unknown, CreateTeamMemberRequest>) =>
  useMutation({
    mutationFn: async (vars: CreateTeamMemberRequest) => (await CreateTeamMember(vars)) as TeamMember,
    ...options,
  });
